import { Nullable } from '../../../common/utils/nullable';

export type RequestBodyForCurrentAccessControl = {
    filters: Filters,
    page: Page,
};

export type Page = {
    size: number,
    number: number,
}

type Filters = {
    systemId: string,
    principal: Nullable<PrincipalFilter>,
    systemResource: SystemResourceFilter,
    resource: Nullable<ResourceFilter>,
    obtainedVia: Nullable<ObtainedViaFilter>,
};

export type PrincipalFilter = {
    type: PrincipalTypeEnum,
    email: Nullable<string>,
    userGroupId: Nullable<string>,
    userGroupType: Nullable<string>,
}

export enum PrincipalTypeEnum {
    User = "User",
    UserGroup = "UserGroup",
}

export type ObtainedViaFilter = {
    name: Nullable<string>,
    type: Nullable<ObtainedViaType>,
}

export type ObtainedViaType = {
    name: ObtainedViaTypes,
    id: Nullable<string>,
    type: Nullable<string>,
}

export enum ObtainedViaTypes {
    UserGroup = "UserGroup",
    SystemUserGroup = "SystemUserGroup",
    DirectAccess = "DirectAccess",
}

export type SystemResourceFilter = {
    type: string,
    name: Nullable<string>,
}

type ResourceFilter = {
    name: Nullable<string>,
    id: Nullable<string>,
}